import Vue from 'vue'
import Vuex from 'vuex'
var _ = require('lodash');
import Api from './Api';
import momentTZ from 'moment-timezone';


momentTZ.tz.link('America/Los_Angeles|America/San_Francisco');

// Asia
momentTZ.tz.link('Asia/Dubai|Asia/Abu Dhabi');
momentTZ.tz.link('Asia/Bangladesh|Asia/Almaty');
momentTZ.tz.link('Asia/Kazakhstan|Asia/Almaty');
momentTZ.tz.link('Asia/Cambodia|Asia/Bangkok');
momentTZ.tz.link('Asia/Saudi Arabia|Europe/Istanbul');
momentTZ.tz.link('Asia/Sri Lanka|Asia/Colombo');
momentTZ.tz.link('Aisa/Vietnam|Asia/Bangkok');

// Africa
momentTZ.tz.link('Africa/Ghana|Africa/Abidjan');
momentTZ.tz.link('Africa/Kenya|Europe/Istanbul');
momentTZ.tz.link('Africa/Tanzania|Europe/Istanbul');
momentTZ.tz.link('Africa/Uganda|Europe/Istanbul');
momentTZ.tz.link('Africa/Morocco|Africa/Algiers');
momentTZ.tz.link('Africa/Nigeria|Africa/Algiers');
momentTZ.tz.link('Africa/Senegal|Africa/Abidjan');

// Europe
momentTZ.tz.link('Europe/Netherlands|Europe/Amsterdam');
momentTZ.tz.link('Europe/Romania|Europe/Athens');
momentTZ.tz.link('Europe/Rwanda|Europe/Athens');
momentTZ.tz.link('Europe/Slovenia|Europe/Amsterdam');


var timeZones = momentTZ.tz.names();
var offsetTmz=[];

for(var i in timeZones)
{
    offsetTmz.push({
        label:  timeZones[i] + " (GMT"+momentTZ.tz(timeZones[i]).format('Z')+")",
        code: timeZones[i]
    });
}

if(localStorage.getItem("client") == "undefined")
{
    localStorage.clear();
}

Vue.use(Vuex)

// const LOGIN = "LOGIN";
// const LOGIN_SUCCESS = "LOGIN_SUCCESS";
// const LOGOUT = "LOGOUT";

export default new Vuex.Store({
    state: {
        isLoggedIn: !!localStorage.getItem("client"),
        validRegistration: (!!localStorage.getItem("registeration.timer") && localStorage.getItem("registeration.timer") > 0),
        apiToken: !_.isEmpty(localStorage.getItem("client")) && localStorage.getItem("client") !== "undefined"  ? JSON.parse(localStorage.getItem("client")).api_token : null,
        timeZones: offsetTmz
    },
    mutations: {
        LOGIN_SUCCESS(state) {
          state.isLoggedIn = true;
          let api_token = JSON.parse(localStorage.getItem("client")).api_token;
          state.apiToken = api_token;
        },
        LOGOUT(state) {
          state.isLoggedIn = false;
          state.apiToken = null;
        },
        registerStarted(state) {
            state.validRegistration = true
        },
        registerEnded(state) {
            state.validRegistration = false
        },

    },
    actions: {
        login({ commit }, payload) {
            // commit(LOGIN); // show spinner
            return new Promise(resolve => {
                setTimeout(() => {
                        localStorage.setItem("client", JSON.stringify(payload.user));
                        commit('LOGIN_SUCCESS');
                        console.log('commit');
                        resolve(true);
                }, 1000);
            });
        },
        logout({ commit }) {
            return new Promise(resolve => {
                localStorage.clear();
                commit('LOGOUT');
            });
        },
        startRegistrationProccess({ commit }, payload){
            return new Promise((resolve, reject) => {
                // setTimeout(() => {
                    localStorage.setItem("registeration.client", JSON.stringify(payload.client));
                    localStorage.setItem("registeration.lists", JSON.stringify(payload.lists));
                    localStorage.setItem("registeration.session_data", JSON.stringify(payload.session_data));
                    localStorage.setItem("registeration.conference_dates", JSON.stringify(payload.conference_dates));
                    localStorage.setItem("registeration.timer", JSON.stringify(payload.session_data.sesstion_lifetime));
                    localStorage.setItem("conference", JSON.stringify(payload.conference));
                    localStorage.setItem("lateRegisterAvailableSLots" , JSON.stringify(payload.available_slots ));
                    commit('registerStarted');
                    resolve('done');
                // }, 1000);
            });
        },
        endRegisrationProccess({ commit }, payload) {
            return new Promise(resolve => {
                // setTimeout(() => {
                    localStorage.removeItem("registeration.client");
                    localStorage.removeItem("registeration.lists");
                    localStorage.removeItem("registeration.session_data");
                    localStorage.removeItem("registeration.conference_dates");
                    localStorage.removeItem("lateRegisterAvailableSLots");
                    localStorage.removeItem("registeration.timer");
                    localStorage.removeItem("client");
                    // localStorage.removeItem("conference");
                    commit('registerEnded');
                    resolve();
                // }, 1000);
            });
        }
    },
    getters: {
        isLoggedIn: state => state.isLoggedIn,
        apiToken: state => !_.isEmpty(state.apiToken) ? state.apiToken : 555,
        validRegistration: state => state.validRegistration
    }
})
